var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("折價券兌換")]), _c('h2', [_vm._v(_vm._s(_vm.timerDisplay))]), _c('div', {
    staticClass: "p-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.couponImage
    }
  }), _c('router-link', {
    staticClass: "button my-3",
    attrs: {
      "to": {
        name: 'LiffHuggiesCouponOfflineFinished'
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("折價完畢")])]), _c('div', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("*門市人員刷修碼後點擊退出")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }